import { render, staticRenderFns } from "./CardBoxComponent.vue?vue&type=template&id=e416c634&scoped=true&"
import script from "./CardBoxComponent.vue?vue&type=script&lang=js&"
export * from "./CardBoxComponent.vue?vue&type=script&lang=js&"
import style0 from "./CardBoxComponent.vue?vue&type=style&index=0&id=e416c634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e416c634",
  null
  
)

export default component.exports